
import { Course } from '../types';

export const final_hearing: Course = {
  id: "final_hearing",
  title: "The Final Hearing",
  description: "The Trial. Submissions, Cross-Examination, and the Final Order.",
  icon: "👨‍⚖️",
  totalModules: 12,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/final_hearing/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is the primary outcome a Judge seeks to achieve at a Final Hearing regarding child arrangements?",
        "o": [
            "To allow new evidence to be introduced by both parties.",
            "To make a Final Order—a lasting, legally binding decision.",
            "To mediate an agreement between the parents for a temporary period.",
            "To decide if the evidence phase should be reopened."
        ],
        "a": 1
    },
    {
        "q": "According to the chronological roadmap, what is the correct sequence of events during the courtroom trial?",
        "o": [
            "Cross-Examination, Oral Evidence, The Judgment, Closing Submissions",
            "Oral Evidence, Cross-Examination, Closing Submissions, The Judgment",
            "Closing Submissions, Oral Evidence, Cross-Examination, The Judgment",
            "The Judgment, Cross-Examination, Oral Evidence, Closing Submissions"
        ],
        "a": 1
    },
    {
        "q": "When providing Oral Evidence in court, which of the following actions is strongly advised to demonstrate you are a 'safe parent'?",
        "o": [
            "Aggressively questioning the other parent's barrister.",
            "Introducing new evidence not previously filed.",
            "Remaining calm, composed, and regulated under questioning.",
            "Speaking quickly to get your points across as efficiently as possible."
        ],
        "a": 2
    },
    {
        "q": "Which of the following accurately describes 'Closing Submissions' and the meaning of an 'Ex-Tempore' judgment?",
        "o": [
            "Closing Submissions happen at the start of the trial, and Ex-Tempore means a delayed judgment.",
            "Closing Submissions are a summary after all witnesses, and Ex-Tempore means an immediate, verbal judgment.",
            "Closing Submissions are for introducing new evidence, and Ex-Tempore means a written decision at a later date.",
            "Closing Submissions are only for self-representing parents, and Ex-Tempore refers to the final written order."
        ],
        "a": 1
    },
    {
        "q": "Regarding a Final Order, which statement is true?",
        "o": [
            "It becomes active only if both parents agree to its terms after sealing.",
            "It typically lasts until the child reaches 18 years of age, and strict compliance is non-negotiable.",
            "Appeals are easily granted if a parent is unhappy with the outcome.",
            "New evidence can be introduced to modify the order after it is sealed."
        ],
        "a": 1
    }
]
};
